/**
 * A document detail response may arrive after a newer hydrate or after the
 * renderer has already saved a newer mutable revision. Only the newest request
 * against the exact object it was sent for may replace that object.
 */
export const hydrationResultIsCurrent = <T>(
  latestRequest: number,
  request: number,
  liveDocument: T | undefined,
  sentDocument: T,
) => latestRequest === request && liveDocument === sentDocument;
